import React from 'react';
import { AppProvider, Page } from '@superops/ui-design-system';
import theme from '../Config/Constants/theme';

function PageLayout({ routeComponent: RouteComponent }) {
  return (
    <AppProvider
      theme={theme}
      i18n={{
        Polaris: {
          Avatar: {
            label: 'Avatar',
            labelWithInitials: 'Avatar with initials {initials}'
          },
          Frame: { skipToContent: 'Skip to content' },
          TopBar: {
            toggleMenuLabel: 'Toggle menu',
            SearchField: {
              clearButtonLabel: 'Clear',
              search: 'Search'
            }
          }
        }
      }}
    >
      <div className="fw fhp">
        <Page fullWidth variant="secondary" contentHeight="1px">
          {RouteComponent}
        </Page>
      </div>
    </AppProvider>
  );
}

export default PageLayout;
